// src/components/Footer.jsx - VERSION MEJORADA CON NEWSLETTER
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) return;
    
    setStatus('loading');
    setMessage('');
    
    try {
      const response = await axios.post(
        '/backend/newsletter/suscribir.php',
        { email, nombre: '' },
        { 
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        }
      );
      
      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message);
        setEmail('');
        
        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      } else {
        setStatus('error');
        setMessage(response.data.message || 'Error al suscribir');
        
        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
      setMessage('Error de conexión con el servidor');
      
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Newsletter Section */}
        <div className="newsletter-section">
          <h3 className="newsletter-title">⚡ Mantente Energizado</h3>
          <p>
            Suscríbete para recibir las últimas novedades y promociones exclusivas
          </p>
          
          {/* Mensaje de estado */}
          {message && (
            <div className={`newsletter-message ${status}`}>
              {status === 'success' && '✅'}
              {status === 'error' && '⚠️'}
              <span>{message}</span>
            </div>
          )}
          
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="tu@email.com" 
              className="newsletter-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={status === 'loading' || status === 'success'}
              required
            />
            <button 
              type="submit" 
              className="newsletter-btn"
              disabled={status === 'loading' || status === 'success'}
            >
              {status === 'loading' ? 'Enviando...' : 
               status === 'success' ? '¡Suscrito!' : 'Suscribirse'}
            </button>
          </form>
        </div>

        <div className="footer-main">
          <div className="footer-brand">
            <div className="logo-image">
              <span>
                ⚡ REANIMEITOR
              </span>
            </div>
            <p className="footer-description">
              La bebida energética que revoluciona el mundo cripto. 
              Energía física meets tokens digitales.
            </p>
           
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Productos</h4>
              <Link to="/#">Todos los Productos</Link>
            </div>

            

            <div className="link-group">
              <h4>Empresa</h4>
              <Link to="/about">Sobre Nosotros</Link>
             
              <Link to="/soporte">Contacto</Link>
            </div>

            <div className="link-group">
              <h4>Legal</h4>
              <Link to="/aviso-legal">Aviso Legal</Link>
              <Link to="/politica-privacidad">Privacidad</Link>
              <Link to="/politica-cookies">Cookies</Link>
              <Link to="/politica-tienda">Términos Tienda</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="payment-methods">
            <span>Métodos de pago:</span>
            <div className="payment-icons">
              <span title="Tarjeta de Crédito" aria-label="Tarjeta de Crédito">💳</span>
            </div>
          </div>

          <div className="footer-copyright">
            <div>© 2026 Reanimeitor. Todos los derechos reservados.</div>
            <div className="design-credit">
              Desarrollado con <strong>⚡ ENERGÍA</strong> y 💛
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;